"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M30 17.5V30H6V6h12.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H3a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V17.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5z" }),
  React.createElement("path", { d: "M23.54 2.853l3.389 3.389-9.546 9.546a.5.5 0 0 0 0 .707l2.117 2.122a.5.5 0 0 0 .707 0l9.546-9.546 3.389 3.389a.5.5 0 0 0 .858-.353V2H23.893a.5.5 0 0 0-.353.853z" })
);

